import { openModal } from 'lib/ui/Modal';

export { default } from './VerifyLocation';

export const openVerifyLocationModal = (location) => openModal('verifyLocation', location);
